import { configureStore } from "@reduxjs/toolkit";
import { useSelector, useDispatch } from "react-redux";
import { authApi } from "../entities/auth";
import { meApi, meReducer } from "../entities/me";
import { presetDataApi } from "../entities/preset-data";
import { adminAccessApi } from "../entities/admin-access";
import { adminCityApi } from "../entities/admin-city";
import { clubsApi } from "../entities/admin-clubs";
import { adminCompetencyApi } from "../entities/admin-competency";
import { adminCountryApi } from "../entities/admin-country";
import { adminBannerApi } from "../entities/admin-banner";
import { fieldActivitiesApi } from "../entities/admin-fieldactivities";
import { hobbiesApi } from "../entities/admin-hobbies";
import { joiningApi } from "../entities/admin-joining";
import { newsApi } from "../entities/admin-news";
import { eventsApi } from "../entities/admin-events";
import { adminCommunitiesApi } from "../entities/admin-communities";
import { adminSubscriptionsApi } from "../entities/admin-subscriptions";
import { raplRequestsApi } from "../entities/admin-raplrequests";
import { connectApi } from "../entities/admin-connect";
import { benefitsApi } from "../entities/admin-benefits";
import { investmentsApi } from "../entities/admin-investments";

export const store = configureStore({
  reducer: {
    [authApi.reducerPath]: authApi.reducer,
    [meApi.reducerPath]: meApi.reducer,
    me: meReducer,
    [presetDataApi.reducerPath]: presetDataApi.reducer,
    [adminAccessApi.reducerPath]: adminAccessApi.reducer,
    [adminCityApi.reducerPath]: adminCityApi.reducer,
    [clubsApi.reducerPath]: clubsApi.reducer,
    [adminCompetencyApi.reducerPath]: adminCompetencyApi.reducer,
    [adminCountryApi.reducerPath]: adminCountryApi.reducer,
    [adminBannerApi.reducerPath]: adminBannerApi.reducer,
    [fieldActivitiesApi.reducerPath]: fieldActivitiesApi.reducer,
    [hobbiesApi.reducerPath]: hobbiesApi.reducer,
    [joiningApi.reducerPath]: joiningApi.reducer,
    [newsApi.reducerPath]: newsApi.reducer,
    [eventsApi.reducerPath]: eventsApi.reducer,
    [adminCommunitiesApi.reducerPath]: adminCommunitiesApi.reducer,
    [adminSubscriptionsApi.reducerPath]: adminSubscriptionsApi.reducer,
    [raplRequestsApi.reducerPath]: raplRequestsApi.reducer,
    [connectApi.reducerPath]: connectApi.reducer,
    [benefitsApi.reducerPath]: benefitsApi.reducer,
    [investmentsApi.reducerPath]: investmentsApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      authApi.middleware,
      meApi.middleware,
      presetDataApi.middleware,
      adminAccessApi.middleware,
      adminCityApi.middleware,
      clubsApi.middleware,
      adminCompetencyApi.middleware,
      adminCountryApi.middleware,
      adminBannerApi.middleware,
      fieldActivitiesApi.middleware,
      hobbiesApi.middleware,
      joiningApi.middleware,
      newsApi.middleware,
      eventsApi.middleware,
      adminCommunitiesApi.middleware,
      adminSubscriptionsApi.middleware,
      raplRequestsApi.middleware,
      connectApi.middleware,
      benefitsApi.middleware,
      investmentsApi.middleware,
    ),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
